import { Unity } from "./unity";
import { User } from "./user";

export class MaintenanceOrder {
    id:number = 0;
    unity_id:number = 0;
    unity:Unity = new Unity;
    description:string = '';
    required_date:Date = new Date();
    status:string = '';
    user_id:number = 0;
    user:User = new User();
    active:boolean = false;
}
